import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Arrow from './Arrow';
import Text from '../../Text';

import * as styles from './SubMenu.module.less';

const SubMenu = ({ links }) => {
  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <li className={styles.pillarNavList}>
      <a
        href={!links.link && links.path ? links.path : undefined}
        onClick={links.link ? () => setSubmenuOpen(!submenuOpen) : undefined}
      >
        <Text
          className={classNames(styles.pillarNavText, styles.pillarNavMenuItem)}
        >
          {links.name}
        </Text>
        {links.link && (
          <Text
            className={classNames(styles.pillarNavArrow, {
              [styles.pillarNavArrowOpen]: submenuOpen,
            })}
          >
            <Arrow />
          </Text>
        )}
      </a>
      <div
        className={classNames(styles.pillarNavSubmenuWrapper, {
          [styles.isOpen]: submenuOpen,
        })}
      >
        {links.link && (
          <ul className={styles.pillarNavSubmenu}>
            {links.link.map(menuLink => (
              <div key={menuLink.category || menuLink.links[0]?.label}>
                {menuLink.category && (
                  <p
                    className={classNames(
                      styles.pillarNavText,
                      styles.blackText
                    )}
                  >
                    {menuLink.category}
                  </p>
                )}
                {menuLink.links.map(submenuLink => (
                  <li key={submenuLink.label}>
                    <a
                      href={submenuLink.path}
                      className={classNames(
                        styles.pillarNavText,
                        styles.submenuLink
                      )}
                    >
                      {submenuLink.label}
                    </a>
                  </li>
                ))}
              </div>
            ))}
          </ul>
        )}
      </div>
    </li>
  );
};

SubMenu.propTypes = {
  links: PropTypes.shape({
    path: PropTypes.string,
    name: PropTypes.string,
    link: PropTypes.arrayOf(
      PropTypes.shape({
        category: PropTypes.string.isRequired,
        links: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
          })
        ),
      })
    ),
  }),
};

SubMenu.defaultProps = {
  links: [],
};
export default SubMenu;
